import { useApi } from 'hooks/api';
import { CompleteInvitationModel, InvitationModel } from 'hooks/invitation';


export interface SupplierModel {
    id: string,
    email: string,
    firstName: string,
    insertion?: string,
    lastName: string,
    address: string,
    houseNumber: string,
    city: string,
    country: string,
    postalCode: string,
    phoneNumber: string,
    kvkNumber: string,
    btwNumber: number,
    bankAccountNumber: string,
    isActive: boolean,
    contactPerson: SupplierContactPersonModel,
    supplierName: string;
    fullName: string;
}

export interface AddSupplierInputModel {
    email: string,
    password: string,
    firstName: string,
    insertion?: string,
    lastName: string,
    address: string,
    houseNumber: string,
    city: string,
    country: string,
    postalCode: string,
    phoneNumber: string,
    kvkNumber: string,
    btwNumber: string,
    bankAccountNumber: string
    contactPerson: AddSupplierContactPersonInputModel,
    supplierName: string
}

export interface AddSupplierContactPersonInputModel {
    firstName: string;
    insertion?: string;
    lastName: string;
    email: string;
    phoneNumber: string;
}

export interface EditSupplierInputModel {
    id: string,
    email: string;
    firstName: string,
    insertion?: string,
    lastName: string,
    address: string,
    houseNumber: string,
    city: string,
    country: string,
    postalCode: string,
    phoneNumber: string,
    kvkNumber: string,
    btwNumber: number,
    bankAccountNumber: string,
    supplierName: string,
    contactPerson: EditSupplierContactPersonInputModel
}

export interface EditSupplierContactPersonInputModel {
    id?: string;
    firstName: string;
    insertion?: string;
    lastName: string;
    email: string;
    phoneNumber: string;
}

export interface SupplierContactPersonModel {
    id?: string;
    firstName: string;
    insertion?: string;
    lastName: string;
    fullName: string;
    email: string;
    phoneNumber: string;
}

export const useSuppliers = () => {
    const { callApi } = useApi();

    const allSuppliers = async () => {
        const response = await callApi.current<SupplierModel[]>('/Supplier/v1/All');

        return response;
    };

    const addSupplier = async (addSupplierInputModel: AddSupplierInputModel) => {
        const response = await callApi.current(
            '/Supplier/v1/Add',
            {
                method: 'POST',
                body: JSON.stringify(addSupplierInputModel)
            }
        );
        return response;
    };

    const editSupplier = async (editSupplierInputModel: EditSupplierInputModel) => {
        const response = await callApi.current(
            '/Supplier/v1/Edit',
            {
                method: 'PUT',
                body: JSON.stringify(editSupplierInputModel)
            }
        );
        return response;
    };

    const reEnableSupplier = async (supplierId: string) => {
        const response = await callApi.current(
            `/Supplier/v1/ReEnable/${supplierId}`,
            {
                method: 'PUT'
            }
        );
        return response;
    };

    const deleteSupplier = async (supplierId: string) => {
        const response = await callApi.current(
            `/Supplier/v1/${supplierId}`,
            {
                method: 'DELETE'
            }
        );
        return response;
    };

    const denySupplier = async (code: string) => {
        const response = await callApi.current(
            `/Supplier/v1/${code}/Deny`,
            {
                method: 'POST',
            }
        );
        return response;
    };

    const acceptSupplier = async (code: string) => {
        const response = await callApi.current(
            `/Supplier/v1/${code}/Accept`,
            {
                method: 'POST',
            }
        );
        return response;
    };

    const invitationSupplierInfo = async (code: string) => {
        const response = await callApi.current<InvitationModel>(`/Supplier/v1/${code}`);
        return response;
    };

    const completeInvitationSupplier = async (completeContentCreatorRegisterModel: CompleteInvitationModel) => {
        const response = await callApi.current('/Supplier/v1/Register/Complete',
            {
                method: 'POST',
                body: JSON.stringify(completeContentCreatorRegisterModel)
            }
        );
        return response;
    };


    return {
        allSuppliers,
        addSupplier,
        editSupplier,
        reEnableSupplier,
        completeInvitationSupplier,
        invitationSupplierInfo,
        denySupplier,
        acceptSupplier,
        deleteSupplier
    };
};